import { useEffect } from 'react';
import tenant from '../../config/tenant';

function hexToRgb(hex) {
  const h = hex.replace('#', '');
  return `${parseInt(h.substring(0, 2), 16)} ${parseInt(h.substring(2, 4), 16)} ${parseInt(h.substring(4, 6), 16)}`;
}

export default function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    const { primary, surface } = tenant.theme;

    
    Object.entries(primary).forEach(([shade, hex]) => {
      root.style.setProperty(`--color-primary-${shade}`, hexToRgb(hex));
    });

    
    Object.entries(surface).forEach(([shade, hex]) => {
      root.style.setProperty(`--color-surface-${shade}`, hexToRgb(hex));
    });

    
    document.title = tenant.branding.appName;
    
    const faviconUrl = tenant.branding?.logoUrl;

    if (faviconUrl) {
      let favicon = document.querySelector('link[rel="icon"]');

      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }

      favicon.href = faviconUrl;
    }
  }, []);

  return children;
}
